// extracted by mini-css-extract-plugin
export default {"Granted":"_8DR3X2FlSwuC75PmFya5","Rejected":"BTHkbizMlE48jZDykLgL","Reason":"E_yYiVCYK6G4oGI5YhAZ"};